// import DataFlow2 from "../../Assets/Icons/DataFlow2";
// import UsersPlus from "../../Assets/Icons/UsersPlus";
// import TooltipBox from "../../Components/TooltipBox";
// import InfoCircle from "../../Assets/Icons/InfoCircle";
// import ToggleButton from "../../Components/ToggleButton";

import { createColumnHelper } from "@tanstack/react-table";
import ToggleButton from "../../Components/ToggleButton";
// import { changeOrgActivationAPI } from "../../Store/Reducers/Organizations/Actions";

const columnHelper = createColumnHelper();

export const columns = (handleChangeActivation, changeActivation) => [
  {
    header: "",
    id: "index",
    disableSortBy: true,
    indexed: true,
    style: "text-center !w-[60px] text-gray",
  },
  columnHelper.accessor("username", {
    header: "Username",
    // meta: {
    //   filterVariant: "text",
    // },
    cell: (info) => info.getValue(),
  }),
  // columnHelper.accessor("plan_id", {
  //   header: "Plan",
  //   // meta: { filterVariant: "text" },
  //   cell: (info) => info.getValue(),
  // }),
  columnHelper.accessor("email", {
    header: "Email",
    // meta: { filterVariant: "text" },
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor("is_active", {
    style: "text-center w-[180px]",
    header: "Activation",
    // meta: {
    //   filterVariant: "switch",
    //   switchOptions: { All: undefined, Active: true, Deactive: false },
    // },

    cell: (info) => {
      return (
        <div className="flex items-center justify-center w-full">
          <ToggleButton
            checked={info.getValue()}
            onChange={() => {
              if (changeActivation) {
                return;
              }
              handleChangeActivation(
                info.row.original?.uuid,
                !info.row.original?.is_active
              );
            }}
          />
        </div>
      );
    },
  }),
  // {
  //   header: "Options",
  //   style: "text-center w-[200px]",
  //   cell: (info) => (
  //     <div>icons</div>
  //     // <div className="flex gap-4 w-full justify-center">
  //     //   <div
  //     //     onClick={() => console.log("info", info.row.original)}
  //     //     className="cursor-pointer"
  //     //   >
  //     //     <TooltipBox content="Add User" id="testId">
  //     //       <UsersPlus />
  //     //     </TooltipBox>
  //     //   </div>
  //     //   <div
  //     //     onClick={() => console.log("info", info.row.original)}
  //     //     className="cursor-pointer"
  //     //   >
  //     //     <TooltipBox content="Tenants" id="testId">
  //     //       <DataFlow2 />
  //     //     </TooltipBox>
  //     //   </div>
  //     //   <div
  //     //     onClick={() =>
  //     //       navigate(
  //     //         `/Organizations/${info.row.original.id}/${info.row.original.name}`
  //     //       )
  //     //     }
  //     //     className="cursor-pointer"
  //     //   >
  //     //     <TooltipBox content="Org. Info" id="testId">
  //     //       <InfoCircle />
  //     //     </TooltipBox>
  //     //   </div>
  //     // </div>
  //   ),
  // },
];
